
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FaDownload, FaTimes } from "react-icons/fa";
import {
  addServiceImage,
  createServices,
  updateServiceById,
terminalServicesTypes
} from "../../Services/terminal";
import { base64ToFile } from "./TerminalForm";
import { omit } from "lodash-es";
import { useParams } from "react-router-dom";
import { validateURL } from "../util/linkValidation";
import { useTranslation } from "react-i18next";
import Select from "react-tailwindcss-select";
const AddService = ({ close, isEdit, serviceData, isAdmin, createdBy }) => {
  const { id } = useParams();
  const [newService, setNewService] = useState({
    title: "",
    description: "",
    imageUrl: null,
    link: "",
    isValidLink: true,
    serviceTypeId: null,
  });
  const [error, setError] = useState({});
  const [success, setSuccess] = useState("");
  const [services, setServices] = useState([]);
  const [service, setService] = useState(null);
  const fileInputRef = useRef(null);
  const { t } = useTranslation();
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  

  const clearImage = () => {
    setNewService({ ...newService, imageUrl: null });
    fileInputRef.current.value = null;
  };
  const handleAddService = () => {
    if (
      !newService.title.trim() ||
      !newService.link ||
      !newService.imageUrl ||
      !newService.isValidLink
    ) {
      setError({ message: t("required_fields") });
      return;
    }
    if (isEdit) {
      updateServiceById(
        newService.id,
        omit(
          { ...newService, terminalId: id },
          "imageUrl",
          "value",
          "label",
          "disabled",
          "createdAt",
          "updatedAt",
          "isValidLink"
        )
      )
        .then((res) => {
          setNewService({ ...newService, isValidLink: true });
          setSuccess(t("service_success"));
          setTimeout(() => {
            setSuccess("");
            close(true);
          }, 2000);
        })
        .catch((e) => {
          setError({ message: e?.response?.data?.message });
        });
    } else {
      if ((isAdmin && createdBy) || !isAdmin) {
        createServices(
          omit({ ...newService, terminalId: id }, "imageUrl"),
          isAdmin ? createdBy : null
        )
          .then((res) => {
            setNewService({ ...newService, isValidLink: true });
            const formData = new FormData();
            formData.append("image", base64ToFile(newService.imageUrl));
            addServiceImage(res.data?.id, formData);
            setSuccess(t("service_success_create"));
            setTimeout(() => {
              setSuccess("");
              close(true);
            }, 2000);
          })
          .catch((e) => {
            setError({message:e?.response?.data?.message});
          });
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file) {
      if (!file.type.startsWith("image/")) {
        setError({ message: t("only_image_files_allowed") });
        return;
      }
      if (file.size > maxSize) {
        setError({ message: t("file_upload_limit_terminal") });
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        setNewService((prev) => ({ ...prev, imageUrl: reader.result, file }));
      };
      setError({});
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (serviceData) {
      setNewService({ ...serviceData, isValidLink: true });
    }
  }, [serviceData]);

  const getServices = useCallback(async () => {
    try {
      const { data } = await terminalServicesTypes();
      const list = data?.data ?? data ?? [];
      const options = Array.isArray(list)
        ? list.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        : [];
      setServices(options);
    } catch (e) {
      console.error("Failed to load service types", e);
    }
  }, []);

  useEffect(() => {
    getServices();
  }, [getServices]);

  // When editing, pre-select the service type in the dropdown
  useEffect(() => {
    if (!isEdit || !serviceData || !services?.length) return;

    const targetId =
      serviceData?.serviceTypeId ?? serviceData?.serviceType?.id ?? null;

    if (!targetId) return;

    const selected = services.find(
      (opt) => String(opt.value) === String(targetId)
    );

    if (selected) {
      setService(selected);
      setNewService((prev) => ({
        ...prev,
        serviceTypeId: selected.value,
      }));
    }
  }, [isEdit, serviceData, services]);
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-4 grid grid-cols-1 gap-4 lg:w-[60%]">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold">
            {isEdit ? "Edit" : "Add"} {t("serviceLabel")}
          </h2>
          <FaTimes
            className="text-gray-500 hover:text-gray-700 cursor-pointer text-xl"
            onClick={() => close()}
          />
        </div>
        {/* <h2 className="text-xl font-semibold">{isEdit ? 'Edit' : 'Add New'} Service</h2> */}
        <Select
                        primaryColor="indigo"
                        placeholder={t("selectServiceLabel")}
                        options={services ?? []}
                        value={service}
                        onChange={(val) => {

                            setNewService((prev) => ({
                                ...prev,
                                serviceTypeId: val?.value || null
                            }));
            
                            setService(val);
                            setError((prev) => ({ ...prev, serviceTypeId: null }));
                        }}
                    />
                    {error?.serviceTypeId && <p className="text-red-500 text-sm mt-1">{String(error?.serviceTypeId)}</p>}
        <input
          type="text"
          placeholder={t("titleLabel")}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          value={newService.title}
          onChange={(e) =>
            setNewService({ ...newService, title: e.target.value })
          }
        />
        <textarea
          placeholder={t("descriptionLabel")}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          value={newService.description}
          onChange={(e) =>
            setNewService({ ...newService, description: e.target.value })
          }
        />
        <input
          type="url"
          placeholder={`${t("webLink")}*`}
          className="w-full px-4 py-2 border border-gray-300 rounded"
          value={newService.link}
          onChange={(e) => {
            if (validateURL(e.target.value)) {
              setNewService({
                ...newService,
                link: e.target.value,
                isValidLink: true,
              });
            } else {
              setNewService({
                ...newService,
                link: e.target.value,
                isValidLink: false,
              });
            }
          }}
        />
        {!newService?.isValidLink && (
          <p className="text-red-500 text-sm mt-1">{t("validurl")}</p>
        )}
        {newService.imageUrl ? (
          <div className="relative bg-gray-100 rounded w-auto py-4 overflow-hidden">
            {!isEdit && (
              <FaTimes
                className="absolute top-1 right-1 text-red-600 bg-white rounded-full p-1 cursor-pointer"
                onClick={clearImage}
                size={18}
              />
            )}
            <a
              className="text-sm mt-0 underline text-blue-600 flex flex-row gap-2"
              href={newService.imageUrl}
              download
              target="_blank"
            >
              {t("download_file")}
              <FaDownload className="text-lg" />
            </a>
          </div>
        ) : (
          <div>
            <button
              className="bg-blue-600 text-white px-4 pt-2 rounded-button w-fit rounded"
              onClick={handleButtonClick}
            >
              {t("chooseFile")}*
            </button>
            <p className="text-sm mt-0">{t("file_upload_limit")}</p>
            <p className="text-sm mt-0 text-ellipsis">
              {t("services_section_info")}
            </p>
          </div>
        )}

        <input
          type="file"
          accept="image/*"
          className="hidden"
          ref={fileInputRef}
          onChange={handleFileChange}
        />
        {error?.message && <p className="text-sm text-red-500 text-center">{error.message}</p>}
        {success && (
          <p className="text-sm text-green-500 text-center">{success}</p>
        )}
        <div className="flex flex-row gap-4 justify-center">
          <button
            onClick={() => close()}
            className="px-4 py-2 border border-gray-300 rounded text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
          >
            {t("cancel")}
          </button>
          <button
            onClick={handleAddService}
            disabled={
              !newService.title.trim() ||
              !newService.link ||
              !newService.imageUrl||
              !newService.serviceTypeId
            }
            className="w-fit px-4 py-2 bg-blue-600 rounded text-white rounded hover:bg-indigo-600 disabled:bg-gray-100 disabled:text-gray-400 disabled:font-black disabled:cursor-not-allowed"
          >
            {isEdit ? t("edit") : t("add")} {t("serviceLabel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddService;